const state = {
  trials: [],
  trialsIam: [],
  loadingTrial: false,
};

const getters = {
  trials(state) {
    return state.trials;
  },
  trialsIam(state) {
    return state.trialsIam;
  },
  loadingTrial(state) {
    return state.loadingTrial;
  },
};

const mutations = {
  UPDATE_TRIALS(state, trials) {
    state.trials = trials;
  },
  UPDATE_TRIALS_IAM(state, trialsIam) {
    state.trialsIam = trialsIam;
  },
  UPDATE_LOADING_TRIAL(state, loadingTrial) {
    state.loadingTrial = loadingTrial;
  },
};

const actions = {
  updateTrials({ commit }, trials) {
    commit("UPDATE_TRIALS", trials);
  },
  updateTrialsIam({ commit }, trialsIam) {
    commit("UPDATE_TRIALS_IAM", trialsIam);
  },
  updateLoadingTrial({ commit }, loadingTrial) {
    commit("UPDATE_LOADING_TRIAL", loadingTrial);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
